import { ApiService } from "./ApiService"

export class CustomerService {

    static uri = '/customer';

    static get({params}) {
        return ApiService.get(`${this.uri}`,
            {
                params,
                headers: {
                    'Content-Type': 'aplication/json',
                    Authorization: `Bearer ${localStorage.getItem('token-radiustrend')}`
                }
            }
        );
    }
}